import React, {Component, useRef, useState } from "react";
import arrowleft from "views/job-details/img/story/leftarrow.png";
import arrowright from "views/job-details/img/story/rightarrow.png";
import story1 from "views/job-details/img/story/story1.png";
import story2 from "views/job-details/img/story/story2.png";
import story3 from "views/job-details/img/story/story3.png";
import story4 from "views/job-details/img/story/story4.png";
import story5 from "views/job-details/img/story/story5.png";
import playbutton from "views/job-details/img/story/play-button.svg";
import { ChevronRight, ChevronLeft } from "react-feather";
import { connect } from "react-redux";

class IndiaStory extends Component {
  render() {
  return (
    <>
      <div className=" container mx-auto  py-20">
        <div className="flex justify-between items-center  mb-8">
          <div>
            <h2 className="fsize28 font-bold">INDIA STORY</h2>
            <h1 className="text505d68 mt-3 fszie18">
              The Micro, Small and Medium Enterprises (MSME) have emerged as a
              vibrant and dynamic sector of the Indian economy
            </h1>
          </div>
        </div>

        <card className="w-full flex  mt-6 mb-12 relative p-8">
          <div className="story-arrows w-full flex justify-between">
            <div>
              <img src={arrowleft} />
            </div>
            <div>
              <img src={arrowright} />
            </div>
          </div>
          <div className="flex items-center w-full">
            <div className="w-1/4 border2px-e2e2e2-r text-center">
              <div>
                <h1 className="fsize44 text07487C font-bold mt-1">₹15L Cr+</h1>
                <p className="text-black opacity-50per fsize20">
                  Lending Opportunities
                </p>
              </div>
            </div>
            <div className="w-1/4 border2px-e2e2e2-r text-center">
              <div>
                <h1 className="fsize44 text07487C font-bold mt-1">29%</h1>
                <p className="text-black opacity-50per fsize20">of GDP</p>
              </div>
            </div>

            <div className="w-1/4 border2px-e2e2e2-r text-center">
              <div>
                <h1 className="fsize44 text07487C font-bold mt-1">40%</h1>
                <p className="text-black opacity-50per fsize20">of Exports</p>
              </div>
            </div>

            <div className="w-1/4 text-center">
              <div>
                <h1 className="fsize44 text07487C font-bold mt-1">63M</h1>
                <p className="text-black opacity-50per fsize20">
                  MSME in India
                </p>
              </div>
            </div>
          </div>
        </card>

        <div>
          <div className="flex justify-end px-12 mb-6">
            <ChevronLeft
              width="30px"
              height="30px"
              className="trend-left-i mr-2 disabled"
            />
            <ChevronRight
              width="30px"
              height="30px"
              className="trend-right-i"
            />
          </div>
          <div class="flex ">
            <div class="mr-8">
              <div class="relative wrapper2">
                <div className="img__wrap">
                  <img src={story1} className="w-full rouned-12px maxh-457px" />
                  <div className="img__description_layer text-center shadow-lg rounded-lg p-20 flex justify-center items-center">
                    <div>
                      <h2 className="fsize20 font-bold">Banks Partner MSME</h2>
                      <p className="line-h26px fsize16 text4B4B4B pt-8 line-clamp-3">
                        in their growth story offering mutiple products and
                        services across life stages of the organisation
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid  grid-cols-2  gap-8">
              <div class="relative wrapper2">
                <div className="img__wrap">
                  <img
                    src={story2}
                    className="w-full h-full bg-white rounded-12px maxh-213px"
                  />
                  <div className="absolute top-0 flex justify-center items-center h-full w-full">
                    <img src={playbutton} />
                  </div>

                  <div className="img__description_layer text-center shadow-lg rounded-lg p-10 flex justify-center items-center">
                    <div>
                      <h2 className="fsize20 font-bold">Business Loan</h2>
                      <p className="line-h26px fsize16 text4B4B4B pt-4 line-clamp-3">
                        Sed ut perspiciatis unde omnis iste natus error sit.
                        Voluptatem accus antium doloremque
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="relative wrapper2">
                <div className="img__wrap">
                  <img
                    src={story3}
                    className="w-full h-full bg-white rounded-12px maxh-213px"
                  />
                  <div className="img__description_layer text-center shadow-lg rounded-lg p-10 flex justify-center items-center">
                    <div>
                      <h2 className="fsize20 font-bold">Wealth Services</h2>
                      <p className="line-h26px fsize16 text4B4B4B pt-4 line-clamp-3">
                        Sed ut perspiciatis unde omnis iste natus error sit.
                        Voluptatem accus antium doloremque
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="relative wrapper2">
                <div className="img__wrap">
                  <img
                    src={story4}
                    className="w-full h-full bg-white rounded-12px maxh-213px"
                  />
                  <div className="img__description_layer text-center shadow-lg rounded-lg p-10 flex justify-center items-center">
                    <div>
                      <h2 className="fsize20 font-bold">
                        Banking, Payment & Collection
                      </h2>
                      <p className="line-h26px fsize16 text4B4B4B pt-4 line-clamp-3">
                        Sed ut perspiciatis unde omnis iste natus error sit.
                        Voluptatem
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="relative wrapper2">
                <div className="img__wrap">
                  <img
                    src={story5}
                    className="w-full h-full bg-white rounded-12px maxh-213px"
                  />{" "}
                  <div className="absolute top-0 flex justify-center items-center h-full w-full">
                    <img src={playbutton} />
                  </div>
                  <div className="img__description_layer text-center shadow-lg rounded-lg p-10 flex justify-center items-center">
                    <div>
                      <h2 className="fsize20 font-bold">
                        Trade Products & Services
                      </h2>
                      <p className="line-h26px fsize16 text4B4B4B pt-4 line-clamp-3">
                        Sed ut perspiciatis unde omnis iste natus error sit.
                        Voluptatem accus antium doloremque
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  }
}

export default IndiaStory;